import { useCallback } from 'react';
import {
  useQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  OperationVariables,
  QueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TiktokBusinessAccountInfo.graphql';
import { Query } from '../../__generated__/globalTypes';

export const useTiktokBusinessAccountInfoQuery = (options?: QueryHookOptions<Query>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTiktokBusinessAccountInfoLazyQuery = (
  options?: LazyQueryHookOptions<Query>
): QueryResult<Query> & { getTiktokBusinessAccountInfoQuery: LazyQueryExecFunction<Query, OperationVariables> } => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  // TODO: should be getTiktokBusinessAccountInfo
  const [getTiktokBusinessAccountInfoQuery, result] = useLazyQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getTiktokBusinessAccountInfoQuery, ...result };
};

export const useTiktokBusinessAccountInfoPromiseQuery = () => {
  const client = useApolloClient();

  const getTiktokBusinessAccountInfo = useCallback(
    (options?: Omit<QueryOptions<Record<string, unknown>, Query>, 'query'>) =>
      client.query<Query>({ ...options, query: QUERY }),
    [client]
  );

  return { getTiktokBusinessAccountInfo };
};
